import { MenuItem, MenuItemProps } from "@mui/material";
import { LinkProps } from "react-router-dom";
import UnstyledLink from "./UnstyledLink";

type LinkMenuItemProps = Pick<LinkProps, "to" | "state"> & MenuItemProps;

export default function LinkMenuItem({ to, state, ...menuItemProps }: LinkMenuItemProps) {
  return (
    <UnstyledLink to={to} state={state}>
      <MenuItem {...menuItemProps} />
    </UnstyledLink>
  );
}
